export default __webpack_public_path__ + "static/media/ngo-gif2.26b2570b.gif";